import './Counter.css';
//#region src/Counter/Counter.module.css
var Counter_module_default = {
	"counterPulse": "yVa9na_counterPulse",
	"wrapper": "yVa9na_wrapper"
};
//#endregion
export { Counter_module_default as default };

//# sourceMappingURL=Counter.module.js.map